export default {
  interested_seller: "interested_seller",
  seller_landing_contact: "seller_landing_contact",
  seller_landing_valuation: "seller_landing_valuation",
  streeteasy_valuation: "streeteasy_valuation"
};
